/** @format */

import React from 'react';
import './styles.scss';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import ArticleLayout from 'components/ArticleLayout';
import Container from 'react-bootstrap/Container';

export default function ArticlePage3(props) {
  const text = props.t('lang_registration:article3');
  const { isMobileView } = props;

  return (
    <>
      <div className='main-container article3'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ArticleLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/image-article-page-3-1.png'}
              subIcon={'images/image-article-page-3-2.png'}
              subIcon1={'images/image-article-page-3-3.png'}
            />
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
